import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Col,
  Row
} from "react-bootstrap";


import Guest from "../../../layouts/Guest";
import EventCheckinWizard from "../../Forms/Private/EventCheckinWizard/CheckinWizard";
import EventCheckAdminForm from "views/Forms/Private/EventCheckForm/EventCheckAdminForm";
import VegeFestCheckAdminForm from "views/Forms/Private/EventCheckForm/VegeFestCheckAdminForm";
import NewYearCheckAdminForm from "views/Forms/Private/EventCheckForm/NewYearCheckAdminForm";

function EventCheckInSearchPage() {

  return (
    <>
      <Guest>
        {/* <EventCheckinWizard /> */}
        <NewYearCheckAdminForm />
        {/* <EventCheckAdminForm /> */}
      </Guest>
    </>
  );
}

export default EventCheckInSearchPage;
